/* src/app/rt-components/navbar/navbar.component.scss */
.buttonNavbar {
  border: none;
  border-radius: 30px !important;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  background-color: lightgrey;
}
.buttonNavbar1:hover {
  color: lightgray !important;
}
.buttonNavbar2:hover {
  color: gray !important;
}
:host {
  background: #ffffff;
  border-bottom: 1px solid #dfe4ed;
  display: block;
  height: 70px;
  left: 220px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9998;
}
@media screen and (max-width: 2048px) {
  :host {
    left: 0;
  }
}
.rtl :host {
  left: 0;
  right: 220px;
}
@media screen and (max-width: 2048px) {
  .rtl :host {
    right: 0;
  }
}
:host .site-navbar {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  padding: 0 22px;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar {
    flex-wrap: wrap;
  }
}
:host .site-navbar .navbar-button {
  cursor: pointer;
  display: none;
  height: 24px;
  margin: 0;
  position: relative;
  transform: rotate(0deg);
  width: 30px;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .navbar-button {
    display: block;
  }
}
:host .site-navbar .navbar-button span {
  background: #3c4e62;
  display: block;
  height: 3px;
  opacity: 1;
  position: absolute;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
  width: 50%;
}
:host .site-navbar .navbar-button span:nth-child(even) {
  left: 50%;
}
:host .site-navbar .navbar-button span:nth-child(odd) {
  left: 0px;
}
:host .site-navbar .navbar-button span:nth-child(1),
:host .site-navbar .navbar-button span:nth-child(2) {
  top: 0px;
}
:host .site-navbar .navbar-button span:nth-child(3),
:host .site-navbar .navbar-button span:nth-child(4) {
  top: 10px;
}
:host .site-navbar .navbar-button span:nth-child(5),
:host .site-navbar .navbar-button span:nth-child(6) {
  top: 20px;
}
:host .site-navbar .navbar-button.open span:nth-child(1),
:host .site-navbar .navbar-button.open span:nth-child(6) {
  transform: rotate(45deg);
}
:host .site-navbar .navbar-button.open span:nth-child(2),
:host .site-navbar .navbar-button.open span:nth-child(5) {
  transform: rotate(-45deg);
}
:host .site-navbar .navbar-button.open span:nth-child(1) {
  left: 3px;
  top: 6px;
}
:host .site-navbar .navbar-button.open span:nth-child(2) {
  left: calc(50% - 3px);
  top: 6px;
}
:host .site-navbar .navbar-button.open span:nth-child(3) {
  left: -50%;
  opacity: 0;
}
:host .site-navbar .navbar-button.open span:nth-child(4) {
  left: 100%;
  opacity: 0;
}
:host .site-navbar .navbar-button.open span:nth-child(5) {
  left: 3px;
  top: 15px;
}
:host .site-navbar .navbar-button.open span:nth-child(6) {
  left: calc(50% - 3px);
  top: 15px;
}
:host .site-navbar .page-title {
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1;
  color: #555555;
  margin: 0;
  width: 100%;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .page-title {
    display: none;
  }
}
:host .site-navbar .nav-items {
  display: flex;
  height: 100%;
  margin: 0 -5px;
}
:host .site-navbar .nav-items .nav-item {
  align-items: center;
  display: flex;
  height: 100%;
  margin: 0 5px;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item {
    position: static;
  }
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button {
  cursor: pointer;
  min-width: 44px;
  padding: 0;
  transition: color 0.2s ease-in-out;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper {
  display: flex;
  height: 100%;
  padding: 5px;
  width: 100%;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .mat-icon,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .mat-icon {
  font-size: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: top;
  width: 30px;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .mat-icon .marker,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .mat-icon .marker {
  background: #00bfff;
  border-radius: 50%;
  height: 6px;
  position: absolute;
  right: 0;
  top: 0;
  width: 6px;
}
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .mat-icon .marker,
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .mat-icon .marker {
  left: 0;
  right: auto;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .avatar,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .avatar {
  border-radius: 50%;
  height: 40px;
  overflow: hidden;
  width: 40px;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .name,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .name {
  white-space: nowrap;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .name,
  :host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .name {
    display: none;
  }
}
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .name,
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .name {
  padding-left: 0;
  padding-right: 10px;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-focus-overlay,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-ripple,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-focus-overlay,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-ripple {
  display: none;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button:hover,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button:hover {
  color: #5dade0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu {
  background: #3c4e62;
  box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.25);
  display: none;
  left: 50%;
  margin: 0 0 0 -150px;
  padding: 0;
  position: absolute;
  top: 100%;
  width: 300px;
  z-index: 9999;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu {
    left: auto;
    margin-left: 0;
    right: 0;
  }
}
@media screen and (max-width: 543px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu {
    left: 0;
    margin-left: 0;
    width: 100%;
  }
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu {
  left: auto;
  margin: 0 -150px 0 0;
  right: 50%;
}
@media screen and (max-width: 2048px) {
  .rtl :host .site-navbar .nav-items .nav-item .dropdown-menu {
    left: 0;
    margin-right: 0;
    right: auto;
  }
}
@media screen and (max-width: 543px) {
  .rtl :host .site-navbar .nav-items .nav-item .dropdown-menu {
    margin-right: 0;
    right: 0;
  }
}
:host .site-navbar .nav-items .nav-item .dropdown-menu:before {
  border: 10px solid transparent;
  border-bottom-color: #3c4e62;
  bottom: 100%;
  content: "";
  left: 50%;
  margin: 0 0 0 -10px;
  position: absolute;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu:before {
    left: 100%;
    margin-left: -34px;
  }
}
@media screen and (max-width: 543px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu:before {
    display: none;
  }
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-title,
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer {
  margin: 0;
  padding: 11px;
  text-align: center;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 16px;
  line-height: 1.3;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer {
  background: #36475a;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer a {
  color: #fff;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer a:hover {
  color: rgba(255, 255, 255, 0.8);
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul {
  list-style-type: none;
  margin: 0;
  max-height: 241px;
  overflow: auto;
  padding: 0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li:last-child {
  border-bottom: 0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a {
  align-items: center;
  color: #fff;
  display: flex;
  padding: 11px;
  transition: background 0.2s ease-in-out;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a:hover {
  background: #5dade0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .mat-icon {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  font-size: 26px;
  height: auto;
  margin-right: 11px;
  padding: 7px;
  width: auto;
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .mat-icon {
  margin-right: 0;
  margin-left: 11px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .avatar {
  border-radius: 50%;
  height: 40px;
  margin-right: 11px;
  width: 40px;
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .avatar {
  margin-right: 0;
  margin-left: 11px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content {
  font-size: 0.85rem;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .desc {
  display: block;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .date {
  display: block;
  font-size: 0.75rem;
  font-style: italic;
  margin-top: 4px;
  opacity: 0.6;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .meta {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
  margin-bottom: 4px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .meta .date {
  margin: 0 0 0 11px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu {
  left: auto;
  right: 0;
  width: 220px;
}
@media screen and (max-width: 543px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu {
    width: 100%;
  }
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu {
  left: 0;
  right: auto;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu:before {
  display: none;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu > ul > li > a {
  padding-top: 8px;
  padding-bottom: 8px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu > ul > li > a .fa {
  margin-right: 11px;
  min-width: 15px;
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu > ul > li > a .fa {
  margin-left: 11px;
  margin-right: 0;
}
:host .site-navbar .nav-items .nav-item.opened ::ng-deep .mat-icon-button,
:host .site-navbar .nav-items .nav-item.opened ::ng-deep .mat-button {
  color: #5dade0;
}
:host .site-navbar .nav-items .nav-item.opened .dropdown-menu {
  display: block;
}
:host .site-navbar .nav-items .nav-item.opened ~ .items-overlay {
  opacity: 1;
  transition: 0.2s opacity 0s ease-in-out, 0s visibility 0s ease-in-out;
  visibility: visible;
}
:host .site-navbar .nav-items .items-overlay {
  background: rgba(60, 78, 98, 0.2);
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: 0.2s opacity 0s ease-in-out, 0s visibility 0.2s ease-in-out;
  visibility: hidden;
  width: 100%;
  z-index: 9998;
}
/*# sourceMappingURL=navbar.component.css.map */
